import React, { Fragment } from 'react';
import styled from 'styled-components';
import { ErrorDto } from 'ts-types/api.types';
import { MessageSourceProps, withMessages } from 'react-message-source';

const ResultsPane = styled.div`
  flex: 0 0 auto;
  margin-right: 15px;
  min-width: 15rem;
  max-width: 36rem;

  .errors-header {
    font-weight: bold;
    font-size: 1.1rem;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 0.5rem;
  }

  .errors-container {
    display: grid;
    grid-template-columns: minmax(min-content, 1fr) minmax(3.5rem, max-content);
    row-gap: 0.35rem;
    column-gap: 1.2rem;
    color: darkred;
  }

`;

export interface TreatmentErrorViewProps extends MessageSourceProps {
  errors: ErrorDto[]
}


const TreatmentErrorView = (props: TreatmentErrorViewProps) => {

  const {
    errors,
    getMessage
  } = props;

  return (
      <ResultsPane>
        <div className="errors-header">{getMessage("error.header")}</div>
        <div className="errors-container">
          {
            errors.map((error, index) => {
              return (
                  <Fragment key={`error-row-${error.errorCode}-${index}`}>
                    <div className="error-index">
                      {index + 1}.
                    </div>
                    <div className="error-errorCode">
                      {getMessage(`error.${error.errorCode}`)}
                    </div>
                  </Fragment>
              );
            })
          }
        </div>
      </ResultsPane>
  );
};

export default withMessages(TreatmentErrorView);
